import {
  LocalizationLanguage,
  QuestionComponentType,
  QuestionDataType,
} from "@green0meter/api-client";

export const INTERCOM_USER_ROLES_DOCS_URL =
  "https://intercom.help/green0meter/en/articles/6217701-user-roles-permissions";
export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_TOTAL_ITEMS = 0;
export const DEFAULT_PAGE_SIZE_OPTIONS = [DEFAULT_PAGE_SIZE, 20, 30, 50];

// Tanstack Query
export const TANSTACK_QUERY_STALE_TIME = 1000 * 60 * 5;

// PBI
export const REPORT_ID = "6b1da26f-9c5f-45c4-88e1-7c3902fe01a4";
export const SUPPLIER_STAGE_REPORT_ID = "497a3775-eb54-4616-b63e-0f9670c97f22";
export const SUPPLIER_PROD_REPORT_ID = "d0fcd0e7-8682-4fe5-a0bb-371c5d093aeb";
export const SFDR_REPORT_ID = "5116dc55-28f0-483f-845e-a8625b32283a";
export const ESRS_REPORT_ID = "d03ca6f8-09f1-4147-983a-3b43a7b9b26a";

export const REPORT_PAGES = {
  GAMIFICATION: "ReportSection9d6759ba1d9f84e51ccb",
  ESG: "ReportSectiondaa2f82dc06455fedefb",
  CO2: "ReportSectionb4c54e0158e46b6152a4",
  CO2_OVERVIEW_MASTER: "ReportSectionb4c54e0158e46b6152a4",
  CO2_OVERVIEW_SUB: "ReportSection2b1ee0310f0a576ee92a",
  CO2_OVERVIEW_ASSET: "ReportSection8c075893389518c289d1",
  CO2_BENCHMARK: "ReportSection7ddcff86292a5c2c6273",
  CO2_TARGETS: "ReportSection4af68ca37222d6abc02e",
  CO2_MODELLING: "ReportSection98989a039c6a4d1dacfa",
  CO2_WATER: "ReportSection1ce8f41a5a9c96344a12",
  CO2_MATERIALS: "ReportSection05d8e1a6039009ee5bd7",
  CO2_SUBSIDIARY_1: "ReportSection5682244425d70d96ec33",
  CO2_SUBSIDIARY_2: "ReportSection62be2a4658b6f6d540d5",
  CO2_SUBSIDIARY_3: "ReportSection76894f773ff292742896",
  CO2_SUBSIDIARY_4: "ReportSection3ea225421a929956d4bf",
  ESG_OVERVIEW_MASTER: "ReportSectiondaa2f82dc06455fedefb",
  ESG_OVERVIEW_SUB: "ReportSectionfc5c578bc6eaf5417f9e",
  ESG_OVERVIEW_ASSET: "ReportSection03162aabc3235a7e6391",
  ESG_BENCHMARK: "ReportSectioncc04ccce6ff7dfe86580",
  ESG_TARGETS: "ReportSection44f8620185dfe5aa7142",
  ESG_DASHBOARD_GRAPH: "ReportSection8ef4ab7a634e1361a055",
  ESG_E: "ReportSectiona64664b55ee12e24d584",
  ESG_S: "ReportSectiona630bede44926636cd62",
  ESG_G: "ReportSectionb615504cbce5ce74d77e",
  SFDR_OVERVIEW_MASTER: "ReportSection",
  SFDR_OVERVIEW_SUB: "ReportSection76ea02ed0cb23dbd2991",
  SFDR_OVERVIEW_ASSET: "ReportSectionde82e2605671d4546a43",
  SFDR_DETAIL: "ReportSection5caf85937a0ad008ca8e",
  SFDR_ASSET_DETAIL: "ReportSection97b7ce706784b5502127",
  CO2_SUBSIDIARY: "ReportSection59480141c01a870487b4",
  CO2_SUBSIDIARY_OVERVIEW: "ReportSectione4d0a4de30c7463a007a",
  ESRS: "cfbaa715cb25d91c14e4",
  BRSR: "cfbaa715cb25d91c14e5",
};

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_DATE_FORMAT_CS = "DD.MM.YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD/MM/YYYY hh:mm";

// TODO: Move to api-client
export type PlatformLanguage = {
  id: LocalizationLanguage;
  code: string;
  name: string;
};

export const PLATFORM_LANGUAGES: PlatformLanguage[] = [
  {
    id: LocalizationLanguage.EN,
    code: "en",
    name: "English",
  },
  {
    id: LocalizationLanguage.CZ,
    code: "cs",
    name: "Czech",
  },
  {
    id: LocalizationLanguage.SK,
    code: "sk",
    name: "Slovak",
  },
  {
    id: LocalizationLanguage.PL,
    code: "pl",
    name: "Polish",
  },
];

export const QUESTION_DATA_TYPE_MAP: Partial<
  Record<QuestionComponentType, QuestionDataType>
> = {
  [QuestionComponentType.MultiInput]: QuestionDataType.QuestionGroup,
  [QuestionComponentType.RichTextBox]: QuestionDataType.String,
  [QuestionComponentType.Checkbox]: QuestionDataType.MultiChoice,
  [QuestionComponentType.DatePicker]: QuestionDataType.Date,
  [QuestionComponentType.Email]: QuestionDataType.String,
  [QuestionComponentType.Files]: QuestionDataType.Files,
  [QuestionComponentType.Number]: QuestionDataType.Number,
  [QuestionComponentType.Radio]: QuestionDataType.MultiChoice,
  [QuestionComponentType.Select]: QuestionDataType.MultiChoice,
  [QuestionComponentType.Slider]: QuestionDataType.Number,
  [QuestionComponentType.ShortText]: QuestionDataType.String,
  [QuestionComponentType.Table]: QuestionDataType.QuestionGroup,
} as const;

export const INTERCOM_APP_ID = "x5vmjbud";

export const OO_SERVER = "https://566b06f2.docs.onlyoffice.com";
export const OO_JWT = "28a388c0798a4db98b30cbd5a6c686a2";

export const QUESTION_ASSISTANT =
  "https://prod-104.westeurope.logic.azure.com:443/workflows/4697f6d6c95c443b945629558d75aaa7/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=9BqybFk77iLMU34WL_88Hm1oTxiYHOOI8nDEX7y4wPs";
